import { BaseDate } from '@insta-club/models';
import Jalaali from 'jalaali-js';

const weekDays = ['یک‌شنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه', 'شنبه'];

const monthNames = [
    'فروردین',
    'اردیبهشت',
    'خرداد',
    'تیر',
    'مرداد',
    'شهریور',
    'مهر',
    'آبان',
    'آذر',
    'دی',
    'بهمن',
    'اسفند'
];

export function formatDuration(seconds: number): string {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const parts: string[] = [];

    if (hrs > 0) parts.push(String(hrs));
    if (hrs > 0 || mins > 0) parts.push(mins.toString().padStart(2, '0'));
    parts.push(secs.toString().padStart(2, '0'));

    return parts.join(':');
}

export function formatDate(date: BaseDate, formatString = '%d %m %y - %h:%i') {
    if (!date) return '';

    let dayName: string;

    if (typeof date.dayOfWeek === 'number') {
        dayName = weekDays[date.dayOfWeek % 7];
    } else {
        dayName = date.dayOfWeek;
    }

    const monthName = monthNames[date.month - 1] ?? date.month.toString();
    const day = date.day.toString();
    const year = date.year.toString();

    const hour = date.h?.toString().padStart(2, '0') ?? '00';
    const minute = date.m?.toString().padStart(2, '0') ?? '00';
    const second = date.s?.toString().padStart(2, '0') ?? '00';

    const formattedDate = formatString
        .replace(/%d/g, day)
        .replace(/%y/g, year)
        .replace(/%m/g, monthName)
        .replace(/%x/g, date.month.toString())
        .replace(/%w/g, dayName)
        .replace(/%h/g, hour)
        .replace(/%i/g, minute)
        .replace(/%s/g, second);

    return formattedDate;
}

export function getReadableJalaaliFromBaseDate(date: BaseDate): string {
    if (!date) return '';

    const { month, day, dayOfWeek } = date;

    const dayName = typeof dayOfWeek === 'number' ? weekDays[dayOfWeek % 7] : dayOfWeek || '';

    const monthName = monthNames[month - 1] ?? month.toString();

    return `${dayName} ${day} ${monthName}`;
}

export const getJalaaliWithAddDay = (day: number) => {
    const date = new Date();
    date.setDate(date.getDate() + day);
    const jDate = Jalaali.toJalaali(date);
    return ' ' + jDate.jy + '/' + jDate.jm + '/' + jDate.jd + ' ';
};

export const getJalaaliWithAddDayReadable = (day: number) => {
    const date = new Date();
    date.setDate(date.getDate() + day);

    const jDate = Jalaali.toJalaali(date);

    const dayOfWeek = date.getDay();

    const readableDate = `${weekDays[dayOfWeek]} ${jDate.jd} ${monthNames[jDate.jm - 1]}`;

    return readableDate;
};

export function isSameJalaaliDate(compareDate: BaseDate, date = new Date()): boolean {
    const { jy: year, jm: month, jd: day } = Jalaali.toJalaali(date);
    return year === compareDate.year && month === compareDate.month && day === compareDate.day;
}

export function isBeforeNowJalaali(compareDate: BaseDate, date = new Date()): boolean {
    const { jy, jm, jd } = Jalaali.toJalaali(date);
    if (jy !== compareDate.year) return jy > compareDate.year;
    if (jm !== compareDate.month) return jm > compareDate.month;
    return jd > compareDate.day;
}

export function secondToDay(second: number) {
    if (!second) return 0;
    return Math.ceil(second / (3600 * 24));
}

export const getJalaaliWeekDayWithAddDay = (day: number): string => {
    const date = new Date();
    date.setDate(date.getDate() + day);
    const dayOfWeek = date.getDay();
    return weekDays[dayOfWeek];
};

